<template>
  <Merchants apiParams="1722"/>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Merchants from "./Merchants";
export default {
  name: "dollarMerchants",
  data() {
    return {
    };
  },
  components: {
  Merchants
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "لیست درگاه ها دلاری",
      },
    ]);
  },
};
</script>
